export default __webpack_public_path__ + "static/media/wagon-wheel-effect-2.5207655f.gif";